export const citySelector = store => store.currentCity;
export const districtSelector = store => store.currentCity.district;
